import { Step, StepIconProps, StepLabel, StepProps, useTheme } from "@mui/material";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { CheckFilledIcon, StatusActiveIcon, StatusInactiveIcon, WarningFilledIcon } from "src/foundations/icons";

export type SenecStepPosition = "start" | "center" | "end";

export interface SenecStepProps extends StepProps {
    key?: string;
    label: string;
    position?: SenecStepPosition;
}

export const SenecStep = ({ key, label, position, ...rest }: SenecStepProps) => {
    return (
        <Step key={key || label} {...rest}>
            <StepLabel StepIconComponent={SenecStepIcon} sx={{ alignItems: `${getLabelPosition(position)} !important` }}>
                {label}
            </StepLabel>
        </Step>
    );
};

const getLabelPosition = (position?: SenecStepPosition) => {
    switch (position) {
        case "start":
            return "flex-start";
        case "end":
            return "flex-end";
        default:
            return "center";
    }
};

const SenecStepIcon = ({ active, completed, error }: StepIconProps) => {
    const theme: SenecFPPTheme = useTheme();
    if (active) {
        return <StatusActiveIcon />;
    }

    if (error) {
        return <WarningFilledIcon />;
    }

    return completed ? <CheckFilledIcon sx={{ color: theme.palette.primary.main }} /> : <StatusInactiveIcon />;
};
